export const TOGGLE_ITINERARY_MODE = 'TOGGLE_ITINERARY_MODE'

export function itineraryModeReducer (state = false, action) {
    switch (action.type){
        case TOGGLE_ITINERARY_MODE:
            return action.payload
        default: return state
    }
}